import { Component } from "react";
import { Button } from "@/components/ui/button";
import { AlertTriangle, RefreshCw } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("ErrorBoundary capturó un error de render:", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="flex flex-col items-center justify-center text-center py-20 px-6"
          data-testid="error-boundary"
        >
          <div className="h-14 w-14 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <AlertTriangle className="h-7 w-7 text-red-500" />
          </div>
          <h2 className="font-heading text-xl font-semibold text-slate-900">
            Algo salió mal en esta sección
          </h2>
          <p className="text-sm text-slate-500 mt-2 max-w-md">
            Ocurrió un error inesperado al mostrar esta pantalla. Tus datos están a salvo. Probá
            reintentar o recargar la página.
          </p>
          <div className="flex gap-2 mt-6">
            <Button onClick={this.reset} data-testid="error-boundary-retry" className="gap-2">
              <RefreshCw className="h-4 w-4" /> Reintentar
            </Button>
            <Button
              variant="outline"
              onClick={() => window.location.reload()}
              data-testid="error-boundary-reload"
            >
              Recargar página
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
